<template>
  <div>
    <b-card>
      <b-form>
        <b-row>
          <!-- {{ journalEntryId }} -->
          <b-col md="6" cols="6" class="my-md-1">
            <b-form-group
              label="Transaction Date"
              label-for="transactionDateInput"
            >
              <b-form-input
                id="transactionDateInput"
                v-model="journalEntryId.date"
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" cols="6" class="my-md-1">
            <b-form-group label="Reference" label-for="referenceInput">
              <b-form-input
                id="referenceInput"
                type="text"
                v-model="journalEntryId.refID"
                readonly
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <b-card class="mt-3">
      <b-spinner
        variant="success"
        label="Spinning"
        block
        v-if="loading"
        style="width: 3rem; height: 3rem"
      ></b-spinner>
      <b-table
        v-if="!loading"
        responsive
        :items="journal.journalEntryLines"
        :fields="tableFields"
        striped
      >
        <template v-slot:cell(ACCOUNT)="row">
          <b-form-select
            v-model="row.item.accountID"
            :options="optionsAccount"
            disabled
          ></b-form-select>
        </template>
        <template v-slot:cell(DEBIT)="row">
          <b-form-input
            type="text"
            v-model="row.item.debit"
            :disabled="row.item.credit !== ''"
          ></b-form-input>
        </template>
        <template v-slot:cell(CREDIT)="row">
          <b-form-input
            type="text"
            v-model="row.item.credit"
            :disabled="row.item.debit !== ''"
          ></b-form-input>
        </template>
        <template v-slot:cell(CONTACT)="row">
          <b-form-select
            v-model="row.item.contactID"
            :options="optionsContact"
            disabled
          ></b-form-select>
        </template>
        <template v-slot:cell(DESCRIPTION)="row">
          <b-form-textarea
            v-model="row.item.description"
            rows="3"
            disabled
          ></b-form-textarea>
        </template>
        <template v-slot:cell(AMOUNT)="row">
          <span>{{ getAmount(row) }}</span>
        </template>
      </b-table>

      <!-- Total Debit and Total Credit -->
      <b-row v-if="!loading">
        <b-col md="12" class="d-flex justify-content-end">
          <div class="py-1 px-2 d-flex">
            <h5>Total Debit:</h5>
            <span class="ml-5">{{ getTotalDebit }}</span>
          </div>
        </b-col>
        <b-col md="12" class="d-flex justify-content-end">
          <div class="py-1 px-2 d-flex">
            <h5>Total Credit:</h5>
            <span class="ml-5">{{ getTotalCredit }}</span>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTable,
  BButton,
  BFormInput,
  BFormTextarea,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormSelect,
  BCard,
  BFormDatepicker,
  BForm,
  VBTooltip,
  BSpinner,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import "bootstrap-vue/dist/bootstrap-vue.css";
import SearchBar from "@/components/search-component/SearchBar.vue";

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BButton,
    BFormInput,
    BFormTextarea,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BFormSelect,
    BCard,
    BFormDatepicker,
    BForm,
    BSpinner,
    SearchBar,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      id: this.$route.params.id,
      date: "",
      journal: {},
      description: "",
      items: [],
      showSpinner: true,
      token: localStorage.getItem("accessToken"),
      tableFields: [
        { key: "ACCOUNT", label: "ACCOUNT", sortable: false },
        { key: "DEBIT", label: "DEBIT", sortable: false },
        { key: "CREDIT", label: "CREDIT", sortable: false },
        { key: "CONTACT", label: "CONTACT", sortable: false },
        { key: "DESCRIPTION", label: "DESCRIPTION", sortable: false },
        { key: "AMOUNT", label: "AMOUNT", sortable: false },
      ],
      loading: true, // Add loading state
      journalentrylines:[],
    };
  },
  computed: {
    getTotalDebit() {
      return this.journal.journalEntryLines ?
      this.journal.journalEntryLines
        .reduce((total, row) => {
          const debit = parseFloat(row.debit);
          return !isNaN(debit) ? total + debit : total;
        }, 0)
        .toFixed(2)
        : 0;
    },
    getTotalCredit() {
      return this.journal.journalEntryLines ?
      this.journal.journalEntryLines
        .reduce((total, row) => {
          const credit = parseFloat(row.credit);
          return !isNaN(credit) ? total + credit : total;
        }, 0)
        .toFixed(2)
        : 0;
    },
    optionsContact() {
      return this.CustomerList.map((v) => ({
        value: v.id,
        text: `${v.otherName ?? v.companyName} ${v.surname ?? ""}`,
      }));
    },

    optionsAccount() {
      return this.chartofaccount.map((v) => ({
        value: v.id,
        text: v.name,
      }));
    },
    ...mapGetters("journalentryModule", {
      journalentry: "journalentry",
      journalEntryId:"id",
      jeLoading: "loading",
    }),
    ...mapGetters("customerModule", {
      CustomerList: "customers",
      custId: "custId",
    }),
    ...mapGetters("chartofaccountModule", {
      chartofaccount: "chartofaccount",
      coaloading: "loading",
    }),
  },
  methods: {
    ...mapActions("journalentryModule", ["getJournalEntryListAction","getJournalEntryIDAction"]),
    ...mapActions("customerModule", [
      "getCustomersListAction",
      "getCustomersByIDAction",
    ]),
    ...mapActions("chartofaccountModule", [
      "getChartOfAccountListAction",
      "addChartOfAccountAction, updateChartOfAccountAction, getChartOfAccountIDAction",
    ]),
    formatDate(date) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    getAmount(row) {
      return row.item && (row.item.debit || row.item.credit)
        ? row.item.debit || row.item.credit
        : "0.00";
    },
    async fetchJournalEntry() {
      try {
        await this.getJournalEntryIDAction(this.id);
        this.journal = this.journalEntryId;
        if(this.journal.journalEntryLines) this.journal.journalEntryLines.sort((a, b) => a.lineID - b.lineID);
      } catch (error) {
        console.error("Error fetching journal entry lines:", error);
      }
    }
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getChartOfAccountListAction();
      await this.fetchJournalEntry();
      if(this.journal.journalEntryLines && this.journal.journalEntryLines.some(x => x.contactID != null))
        await this.getCustomersListAction();
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
      this.loading = false;
    }
  },
};
</script>
